export { default as VAuthCallback } from './VAuthCallback.vue'
export { default as VAuthCallbackError } from './VAuthCallbackError.vue'
